
import React from "react";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";

export interface PartnersProps {
    sponsors: string[];
}

function Partners({ sponsors }: PartnersProps) {
    return (<section className={styles["section-tight"]}>
        <div className={styles["container"]}>
            <h2 className={styles["h1"]}>{i18nManager.Labels.home.partners}</h2>
            <div className={styles["partner-grid"]}>
                {sponsors.map((s) => (<div key={s} className={styles["partner"]}>
                    <img src={s} alt="" loading="lazy" />
                </div>))}
            </div>
        </div>
    </section>);
}

export default Partners;
